import React, { useMemo } from 'react';
import { BubbleChart } from "@carbon/charts-react";
import { useTranslation } from "react-i18next";
import ChartPanelWrapper from "../ChartPanelWrapper";
import { transformToGroupValue, addIndexAndRadius, buildChartTitle, buildXAxisTitle, buildYAxisTitle, buildColorScale } from "../chartHelpers";

const Index = ({chart}) => {
    const { t } = useTranslation();
    const radiusLabel = chart.y_columns?.[0]?.column_name?.toUpperCase() || 'COUNT';

    const chartOptions = useMemo(() => ({
        title: buildChartTitle(chart),
        resizable: true,
        height: "400px",
        axes: {
            bottom: {
                scaleType: "linear",
                mapsTo: "key",
                includeZero: false,
                title: buildXAxisTitle(chart) || t('panels.indexAxis')
            },
            left: {
                scaleType: "linear",
                mapsTo: "value",
                includeZero: false,
                title: buildYAxisTitle(chart) || 'COUNT'
            }
        },
        bubble: { radiusMapsTo: "radius", radiusLabel },
        legend: { enabled: false }
    }), [chart, radiusLabel, t]);

    return (
        <ChartPanelWrapper chart={chart}>
            {(panelData, renderChart) => {
                const data = addIndexAndRadius(transformToGroupValue(panelData, chart));
                const colorScale = buildColorScale(data);
                const options = {
                    ...chartOptions,
                    color: { scale: colorScale }
                };
                return renderChart(data, <BubbleChart options={options} data={data} />);
            }}
        </ChartPanelWrapper>
    );
}

export default React.memo(Index)
